import React, { useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getAllProducts } from '../../redux/actions/Product/ProductActions';
import { deleteProduct } from '../../redux/actions/Product/ProductActions';
import { toast } from 'react-toastify';
import {Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ProductStyle.css';
toast.configure();
//Get All Products
const ProductList = ({products, getAllProducts, deleteProduct}) =>{
    useEffect(()=> {
        if(products && products.length===0)
            getAllProducts();
        console.log('use Effect',products.length);
    },[products]);
    const [Allproducts,setAllProducts] = useState([]);
    useEffect(()=> {
        setAllProducts(products);
        console.log('use Effect',Allproducts.length);
    },[products]);
    
    const handleDelete = (id) => {
        console.log('from handle delete '+id);
        deleteProduct(id)
            .then(() => {
                toast.success('Deleted Successfully', {autoClose:3000},{
                    transition: Zoom
                });
                setTimeout(function () {
                    getAllProducts(); //will redirect to your blog page (an ex: blog.html)
                }, 3000);
                
                
                //
            })
            .catch((error) => {
                console.log(error);
            });
    };
    console.log('all Products',products);
    return(
        <div className='headerList' style={{marginBottom:'4vw'}}>
            <h1 className='shadow-lg p-3 mb-5 bg-white rounded'>Products</h1>
            <div className='add-product-button'>
                <Link className="btn btn-primary mx-2" to={'/product/create'}> {/* Handle Remainig */}
                Add Product
                </Link>
            </div>
            <div className='SearchPage'>
                <div className="input-group mb-3 search-box">
                    <input type="text" className="form-control" placeholder="Product's Name" val/>
                    <button className="btn btn-outline-secondary" type="searchButton" id="button-addon2" to={'/product/search/:name'}>Search</button>
                </div>
                <div className='product-table'>
                    <table className="table table-hover table-striped">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Name</th>
                                <th scope="col">DESCRIPTION</th>
                                <th scope="col">QUANTITY</th>
                                <th scope="col">TYPE</th>
                                <th scope="col">DATE</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Allproducts.map((val, key) => {
                                console.log('hi '+products);
                                return(
                                    <tr key={key}>
                                        <th scope="row">{val.productId}</th>
                                        <td>{val.productName}</td>
                                        <td>{val.productDescription}</td>
                                        <td>{val.productQuantity}</td>
                                        <td>{val.productType}</td>
                                        <td>{val.date}</td>
                                        <td>
                                            <Link className="btn btn-success mx-2" to={`/get/${val.productId}`} >
                                            View
                                            </Link>
                                            <Link className="btn btn-primary mx-2" to={`/product/update/${val.productId}`}>
                                            Update
                                            </Link>
                                            <button className="btn btn-danger" onClick={() => handleDelete(val.productId)}>
                                            Delete
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    console.log('Map State to Props',state);
    return {
        products: state.products
    };
};

const mapDispatchToProps = {
    getAllProducts,
    deleteProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
